<template>
  <div class="intro">
    <img src="../../assets/NewYear/Tape.png" class="tape" />
    <div class="intro-container">
      <p>
        Je suis sorti prendre l'air en ce matin du 31 Décembre et je fus surpris de découvrir, au
        bout de la digue, un homme à l'allure très étrange en train d'enterrer quelque chose dans le
        sable. Plus qu'étrange, je dirais même qu'il était effrayant.
      </p>
      <p>
        Je restais à l'observer discrètement, de loin, faisant mine de laisser voguer mon regard
        vers le large. Il termina sa besogne et s'éloigna en filant vers le nord. Cela ne fit
        qu'accentuer mon malaise. Je pensais qu'il reviendrait vers la digue, que je pourrais le
        croiser ce qui me rassurerait sur son apparence. Au lieu de ça, je me demandais ce qu'il
        pouvait bien aller faire dans cette direction.
      </p>
      <p>
        J'attendais, attendais encore, mais il ne revint pas. J'attendis donc encore un peu, au cas
        où, et pris la décision (un peu craintif, je l'avoue) d'aller voir ce qu'il avait enterré.
        Quelle ne fut pas ma surprise de découvrir l'horloge cadenassée que vous voyez sur mon
        étagère ! En effet, une histoire que me racontait ma grand-mère avant chaque réveillon me
        revint immédiatemment en mémoire. Une histoire pour nous aider, mes cousins et moi, à passer
        le temps jusqu'à la fête de la soirée, histoire qui nous amusait beaucoup et que nous lui
        réclamions chaque année. C'était l'histoire d'un comte grâce à qui la nouvelle année pouvait
        avoir lieu. Il possèdait pour cela une horloge magique qu'il devait remonter le 31 Décembre
        juste avant minuit. Bien évidemment chaque année, il lui arrivait une mésaventure : il
        pouvait perdre l'horloge, se la faire voler... et ma grand-mère, en tant que soit-disant
        amie du comte, lui envoyait une bande d'enfants intrépides qui venaient à sa rescousse pour
        l'aider à retrouver l'horloge ! Nous nous imaginions vivre les mêmes aventures mes cousins
        et moi, complètement captivés par ses récits.
      </p>
      <p>
        Bien entendu, ce ne sont là que des histoires que l'on raconte aux enfants. Pourtant, depuis
        que je suis tombé sur cette horloge ce matin, je ne peux m'empêcher d'avoir un mauvais
        pressentiment. J'ai retrouvé quelques pages de l'un de ces vieux contes que nous lisait ma
        grand-mère. Les relire ne m'a pas réconforté. Cela parait peut-être incroyable, mais
        qu'arriverait-il ce soir si c'était l'horloge du comte qui se trouvait là sous nos yeux ?
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro"
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Kalam&display=swap");
p {
  font-family: "Kalam", cursive;
  font-size: 21px;
}
.intro {
  top: 0;
  position: relative;
  margin: 0;
  height: 92%;
}
.intro-container {
  width: 78%;
  height: 85%;
  margin: 8%;
  padding: 3%;
  background: rgb(235, 235, 235);
  overflow: scroll;
}
.tape {
  position: absolute;
  height: 12%;
  top: -6%;
  left: 32%;
}
</style>
